/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
}

export function base64toFile(base64, filename) {
  var arr = base64.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {type:mime});
}

// 获取当前日期的前几天
export function getBeforeDate(n) {
  let date = new Date()
  let year,month,day
  date.setDate(date.getDate()-n)
  year = date.getFullYear()
  month = date.getMonth() + 1
  day = date.getDay()

  let s = year + '-' + (month < 10 ? ('0' + month) : month) + '-' + (day < 10 ? ('0' + day) : day)
  return s
}

// 获取当前时间的年月日时分秒
export function getCurrentTime() {
  let keep = ''
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month < 10 ? '0' + month : month
  let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let minu = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  keep = year+'-'+month+'-'+day+' '+hour+':'+minu+':'+second
  return keep
}

// 获取当前日期
export function getCurrentDate() {
  let keep = ''
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month < 10 ? '0' + month : month
  let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

  keep = year+'-'+month+'-'+day
  return keep
}

export function getBetweenDate(start,  end) {
  let end_day = end.split('-')[1] + '/' + end.split('-')[2]
  let getDate = function(str) {
    let temp = new Date()
    let list = str.split('-')
    temp.setFullYear(list[0])
    temp.setMonth(list[1] - 1)
    temp.setDate(list[2])
    return temp
  }
  let date1 = getDate(start)
  let date2 = getDate(end)
  if (date1 > date2) {
    let temp = date1
    date2 = date1
    date1 = temp
  }
  date1.setDate(date1.getDate())
  let dateArr = []
  let i = 0
  while (!(date1.getFullYear() == date2.getFullYear()
    && date1.getMonth() == date2.getMonth()
    && date1.getDate() == date2.getDate())) {
    let dayStr = date1.getDate().toString()
    let monthStr = date1.getMonth() + 1
    if (dayStr.length == 1) {
      dayStr = '0' + dayStr
    }
    if (monthStr < 10) {
      monthStr = '0' + monthStr
    }
    dateArr[i] = monthStr + '/' + dayStr
    i++
    date1.setDate(date1.getDate() + 1)
  }
  dateArr.push(end_day)
  return dateArr
}